import { useParams } from "react-router-dom";
import { useFetchData, usePostApiRequest } from "../helpers/api";
import SEO from "../components/seo";
import Breadcrumb from "../wrappers/breadcrumb/Breadcrumb";
import LayoutTwo from "../layouts/LayoutTwo";
import LoadingScreen from "../components/loading/LoadingScreen";
import ProductImageDescription from "../wrappers/product/ProductImageDescription";
import ProductDescriptionTab from "../wrappers/product/ProductDescriptionTab";
import Cookies from "js-cookie";
import { useEffect } from "react";
import Swiper, { SwiperSlide } from "../components/swiper";
import CategoryItem from "./category/CategoryItem";

const customerId = Cookies.get("kalista-web-Id");
const settings = {
  loop: false,
  grabCursor: true,
  observer: true,
  observeParents: true,
  spaceBetween: 30,
  breakpoints: {
    320: {
      slidesPerView: 1,
    },
    576: {
      slidesPerView: 2,
    },
    1024: {
      slidesPerView: 3,
    },
  },
};

const Product = () => {
  let { id } = useParams();
  const customerCodeStore = useParams();
  const customerCode = customerCodeStore?.UserCode;

  const postApiRequest = usePostApiRequest();
  const { data: singleProductData, isLoading } = useFetchData(
    "getProductByStylCode",
    "/Customer/GetProductByStylCode",
    { StyleCode: id },
    id
  );
  const productData = singleProductData?.Data || [];
  const grpNo = productData[0]?.GrpNo || 0;

  const excludedGrpNos = [0, 9, 10, 12, 72];
  const { data: productSizeData, isLoadingSize } = useFetchData(
    ["singleProductSize"],
    "/Customer/GetItemSize",
    { CategoryId: grpNo },
    grpNo,
    { enabled: !excludedGrpNos.includes(grpNo) }
  );
  const sizeData = productSizeData?.Data || [];

  // const { data: productHistoryData, isLoadingHistory } = useFetchData(
  //   "productHistoryData",
  //   "/Customer/GetRecentlyVisited",
  //   { CustomerCode: customerId, StyleCode: id },
  //   id,
  //   { enabled: !!customerId }
  // );
  // const historyData = productHistoryData?.Data || [];

  // useEffect(() => {
  //   if (!customerId) return;

  //   const SaveHistoryData = () => {
  //     postApiRequest({
  //       url: "/Customer/SaveRecentlyVisited",
  //       method: "POST",
  //       data: { CustomerCode: customerId, StyleCode: id },
  //       noToast: true,
  //     });
  //   };

  //   SaveHistoryData();
  //   // eslint-disable-next-line
  // }, [id]);

  return (
    <>
      <SEO titleTemplate="Product Page" description="Product Page" />

      <LayoutTwo>
        {productData[0] && (
          <Breadcrumb
            pages={[
              { label: "Home", path: `/${customerCode}` },
              {
                label: productData[0]?.GrpName || "",
                path: productData[0]?.GrpName
                  ? `/${customerCode}/category/${productData[0]?.GrpNo || `/${customerCode}`}`
                  : "",
              },
              ...(productData[0]?.DesgGroupName
                ? [
                  {
                    label: productData[0]?.DesgGroupName,
                    path: `/${customerCode}/collection/${productData[0]?.DesgGroupNo || `/${customerCode}`}`,
                  },
                ]
                : []),
              {
                label: productData[0]?.StyleCode || id,
                path: "#",
              },
            ].filter((page) => page.label)}
          />
        )}

        {isLoading || isLoadingSize ? (
          <LoadingScreen />
        ) : (
          productData[0] && (
            <>
              <ProductImageDescription
                spaceTopClass="pt-30"
                product={productData[0]}
                sizeData={sizeData}
              />
              <ProductDescriptionTab
                spaceBottomClass="pb-90"
                product={productData[0]}
              />
              {/* {historyData && historyData?.length > 0 ? (
                <section className="home_product_slider">
                  <div className="section_title_1">
                    <h2>RECENTLY VIEWED PRODUCTS</h2>
                  </div>
                  <div className="container">
                    <Swiper options={settings}>
                      {historyData.map((product) => (
                        <SwiperSlide key={product.StyleId}>
                          <CategoryItem product={product} showSizes="false" />
                        </SwiperSlide>
                      ))}
                    </Swiper>
                  </div>
                </section>
              ) : (
                ""
              )} */}
            </>
          )
        )}
      </LayoutTwo>
    </>
  );
};

export default Product;
